import React, { useCallback, useEffect, useRef, useState } from 'react';
import classes from './JackpotLabel.module.scss';
import { useJackpotsForGame } from '@homeplay/hooks';
import CountUp from 'react-countup';
import { formatBalance } from '@homeplay/utils';

const JackpotCounter = React.memo(({ balance = 0 }) => {
  const previousBalanceRef = useRef(balance);
  const hasMountedRef = useRef(false);

  useEffect(() => {
    hasMountedRef.current = true;
    previousBalanceRef.current = balance;
  }, [balance]);

  const getStartValue = () => {
    const previous = Number(previousBalanceRef.current) || 0;
    const current = Number(balance) || 0;
    
    if (current < previous) {
      return 0;
    }
    
    if (previous === current) {
      return hasMountedRef.current ? current : Math.max(0, current - 50);
    }
    return Math.max(0, previous);
  };

  return (
    <CountUp
      start={getStartValue()}
      end={balance || 0}
      duration={30}
      preserveValue
      formattingFn={(v) => formatBalance(v)}
    />
  );
});

// TODO: never rendered, jackpot_lifecycles[].games is always empty (see useJackpotsForGame)
const JackpotLabel = ({ slug }) => {
  const [open, setOpen] = useState(false);
  const { jackpotsForGame } = useJackpotsForGame(slug);

  const onToggle = useCallback((e) => {
    e && (e.preventDefault?.(), e.stopPropagation?.());
    setOpen((p) => !p);
  }, []);

  const onClose = useCallback((e) => {
    e && (e.preventDefault?.(), e.stopPropagation?.());
    setOpen(false);
  }, []);

  if (!jackpotsForGame?.length) return null;

  return (
    <div
      className={`jackpot-label ${classes.Root}`}
      data-slug={slug}
      data-open={open ? '1' : '0'}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onToggle(e);
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={open}
    >
      <div className={classes.Button}>
        <span className={classes.Text}>JACKPOT</span>
      </div>
      <div className={classes.Popup} data-open={open ? '1' : '0'} onClick={onClose}>
        <div className={classes.PopupInner}>
          {jackpotsForGame.map((jp) => {
            if (jp.winnerName) return null;
            return (
              <div className={classes.Counter} key={jp.slug}>
                <span className={classes.CounterName}>{String(jp.name || jp.slug)}</span>
                <span className={classes.CounterValue}>
                  <JackpotCounter balance={jp.balance} />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(JackpotLabel);


